import 'bootstrap/dist/css/bootstrap.min.css'
import { ThemeContextProvider } from '../Context/ThemeContext'
import Home from '../components/Home/Home'

function App() {
  return (
    <ThemeContextProvider>
      <Home />
    </ThemeContextProvider>
  )
}

export default App
